module.exports = __webpack_public_path__ + "media/images/upwise-blue-check-ec65c2d8.svg";